<p-messages severity="warn"
  *ngIf="_showCustom && msg">
  <ng-template pTemplate>
    <div class="p-m-2">{{msg['msg']}}</div>
    <a target="_blank"
      [href]="msg['ref']">{{msg['refMsg']}}</a>
  </ng-template>
</p-messages>
<p-toast position="top-center"></p-toast>

<div id="login-component" class="tela">
  <main class="login">
    <div class="login-conteudo">
      <div class="logo cm-logo" role="img" aria-label="Central do Cliente Hábil">
        <span class="cm-logo-marca"></span>
        <span class="cm-logo-produto">Central do Cliente</span>
      </div>

      <h1 class="titulo-login">Acesse sua conta</h1>
      <p class="sub">Informe seu usuário e senha da Central do Cliente.</p>

      <div class="login-field">
        <label class="login-label" for="usuario">Usuário</label>
        <span class="p-input-icon-left">
          <i class="pi pi-user"></i>
          <input type="text"
            pInputText
            autocomplete="username"
            [ngClass]="login?.length ? 'user-upper' : ''"
            placeholder="Seu usuário"
            id="usuario"
            [(ngModel)]="login"
            (keyup.enter)="entrar()">
        </span>
      </div>

      <div class="login-field">
        <label class="login-label" for="password">Senha</label>
        <span class="p-input-icon-left campo-senha">
          <i class="pi pi-lock"></i>
          <input [type]="_type"
            pInputText
            autocomplete="current-password"
            placeholder="Sua senha"
            id="password"
            [(ngModel)]="password"
            (keyup.enter)="entrar()">
          <button type="button"
            class="olho"
            [attr.aria-label]="_pwd_visible ? 'Esconder senha' : 'Mostrar senha'"
            (click)="changeVisibility()">
            <i [class]="_icon"></i>
          </button>
        </span>
      </div>

      <button pButton
        type="button"
        class="entrar-btn"
        [disabled]="_loading"
        (click)="entrar()"
        label="Entrar"></button>

      <p-progressBar *ngIf="_loading"
        class="carregando"
        mode="indeterminate"
        [style]="{ height: '6px' }">
      </p-progressBar>
    </div>

    <footer class="rodape">
      <span>Central do Cliente</span>
      <span>© {{ ano }} Hábil Software</span>
    </footer>
  </main>

  <section class="marca">
    <div class="enfeite enfeite-1" aria-hidden="true"></div>
    <div class="enfeite enfeite-2" aria-hidden="true"></div>

    <div class="marca-conteudo">
      <h2>Central do Cliente</h2>
    </div>
  </section>
</div>
